import React, { useContext, useEffect, useState } from 'react';
import PrivateLayout from '../../layouts/PrivateLayout/PrivateLayout';
import { Button, Card, Datepicker, Dropdown, Spinner } from 'flowbite-react';
import { FaCheck, FaFilter, FaExchangeAlt } from 'react-icons/fa';
import CustomButton from '../../components/CustomButton/CustomButton';
import { VictoryAxis, VictoryBar, VictoryChart, VictoryLegend, VictoryLine, VictoryTheme, VictoryTooltip } from 'victory';
import client from '../../api/client';
import { numberWithCommas } from '../../utils/formatNumber';
import { UserContext } from '../../contexts/UserContext';
import { useCurrency } from '../../contexts/CurrencyContext';
import { Link } from 'react-router-dom';
import CustomModal from '../../components/Modal/CustomModal';
import FundWalletModal from '../Payouts/Transfers/FundWalletModal/FundWalletModal';
import icon from '../../assets/wallet.png'
import MakeTransferModal from '../Payouts/Transfers/MakeTransferModal/MakeTransferModal';
import { BiPaperPlane, BiWallet } from 'react-icons/bi';
import NotificationPopupModal from '../../components/NotificationPopupModal/NotificationPopupModal';
import OtpVerificationModal from '../../components/OtpVerificationModal/OtpVerificationModal';
import showToast from '../../components/CustomToast/toastHelper';
import logo from '../../assets/Ideos.png'



interface DashboardProps {
    businessName: string;
}
const Dashboard = ({ businessName }: DashboardProps) => {
    const { userDetails } = useContext(UserContext) ?? {};
    const [selectedItem, setSelectedItem] = useState('week');
    const [summary, setSummary] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(true);
    const [status, setStatus] = useState<string>();
    const [openModal, setOpenModal] = useState<boolean>(false)
    const [openTransferModal, setOpenTransferModal] = useState<boolean>(false)
    const [openPinModal, setOpenPinModal] = useState<boolean>(false)
    const [openOtpModal, setOpenOtpModal] = useState<boolean>(false)
    const [type, setType] = useState<string>('intro')
    const [balances, setBalances] = useState<any[]>()
    const { currency } = useCurrency();
    const [filter, setFilter] = useState<any>({
        fromDate: '',
        toDate: '',
    });
    const [graphData, setGraphData] = useState<{ x: string, inflow: number, outflow: number }[]>([]);
    const [sendingOtp, setSendingOtp] = useState<boolean>(false)

    useEffect(() => {
        if (userDetails) {
            let { activeSubsidiary } = userDetails;
            setStatus(activeSubsidiary.status);
        }
    }, [userDetails]);

    const handleItemSelected = (item: string) => {
        setSelectedItem(item);
    };

    const handleDateChange = (fromDate: string, toDate: string) => {
        setFilter({ fromDate, toDate });
    };

    useEffect(() => {
        const fetchData = async () => {
            await getSummary();
            await getGraphData();
            await fetchBalances()
        };
        fetchData();
    }, [currency, selectedItem, filter]);

    const getSummary = async () => {
        try {
            const response = await client.get(`/subsidiary/metric/transaction/summary?currency=${currency}`);
            setSummary(response.data.data);
            setLoading(false);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
            }
        }
    };

    const fetchBalances = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/get/wallet/balance');

            setBalances(response.data.wallets);
            const message = response?.data?.message;
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const handleSendOtp = async () => {
        try {
            setSendingOtp(true)
            const response = await client.post('/subsidiary/dashboard/pin/reset/send-otp', null);
            const message = response?.data?.message;
            showToast(message, "success")
        } catch (err: any) {

            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                const message = err?.response?.data?.message;
                showToast(message, "error")
            }
        }
        finally {
            setSendingOtp(false)
        }
    }

    const handleCallToAction = () => {
        // if(type == 'intro'){
        //   setType('pinCreationMessage')
        // }
        // else if(type == "pinCreationMessage"){
        setType('pinCreationMessage')
        handleSendOtp()
        setOpenPinModal(false)
        setOpenOtpModal(true)
        // }
    }

    // useEffect(() => {
    //     if (userDetails) {
    //         console.log(userDetails);

    //         if (userDetails?.user?.pin == null && userDetails?.activeSubsidiary?.verificationStatus == "Active") {
    //             setOpenPinModal(true)
    //         }
    //     }
    // }, [])

    const ngnBalance = balances?.find(balance => balance.currencyShortName == currency);

    const getGraphData = async () => {
        try {
            const { fromDate, toDate } = filter;
            const response = await client.get(
                `/subsidiary/metric/inflow/outflow?type=${selectedItem}&currency=${currency}&fromDate=${fromDate}&toDate=${toDate}`
            );
            const data = response.data.data
            const dayAbbreviations: any = {
                Monday: 'Mon',
                Tuesday: 'Tue',
                Wednesday: 'Wed',
                Thursday: 'Thu',
                Friday: 'Fri',
                Saturday: 'Sat',
                Sunday: 'Sun',
            };

            const monthAbbreviations: any = {
                January: 'Jan',
                February: 'Feb',
                March: 'Mar',
                April: 'Apr',
                May: 'May',
                June: 'Jun',
                July: 'Jul',
                August: 'Aug',
                September: 'Sep',
                October: 'Oct',
                November: 'Nov',
                December: 'Dec',
            };
            const transformedData = data.map((item: any) => {
                let abbreviatedNameDate = item.nameDate;

                if (selectedItem === 'week') {
                    abbreviatedNameDate = dayAbbreviations[item.nameDate] || item.nameDate;
                } else if (selectedItem === 'year') {
                    abbreviatedNameDate = monthAbbreviations[item.nameDate] || item.nameDate;
                }

                return {
                    x: abbreviatedNameDate,
                    inflow: item.inflow,
                    outflow: item.outflow,
                };
            });

            setGraphData(transformedData);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
            }
        }
    };

    return loading ? (
        <div className='flex justify-center items-center min-h-screen'>
            <div className=" inset-0 z-50 flex items-center justify-center bg-white/70">
                <img src={logo} alt="Loading..." className="w-16 animate-spin" />
            </div>        </div>

    ) : (
        <div className='px-8 py-4'>
            <div className='flex mt-4 gap-2'>
                <p className='text-xl '>Hi, {businessName}</p>
                {status == 'Active' ? (
                    <div className='flex justify-center items-center h-5 w-5 bg-custom-button-green rounded-full'>
                        <FaCheck color='white' size={12} />
                    </div>
                ) : null}
            </div>
            <hr />
            <div className='mt-4 grid grid-cols-1 md:grid-cols-3 gap-4'>
                <Card className='h-full flex flex-col shadow-none'>
                    <div className='flex flex-col justify-start flex-grow'>
                        <p className='mb-4 text-sm'>Transaction values</p>
                        <div className='flex gap-3'>
                            <p className='text-sm'>{currency}</p>
                            <p className='text-3xl font-bold'>{numberWithCommas(summary.volume)}</p>
                        </div>
                    </div>
                </Card>
                <Card className='h-full flex flex-col shadow-none '>
                    <div className='flex flex-col flex-grow'>
                        <p className='mb-4 text-sm'>Transaction Count</p>
                        <div className='flex gap-3'>
                            <p className='text-3xl font-bold'>{summary.count}</p>
                        </div>
                    </div>
                </Card>
                <Card className='h-full flex flex-col shadow-none'>
                    <div className='flex flex-col justify-start flex-grow'>
                        <p className='mb-4 text-sm'>Transaction settlements</p>
                        <div className='flex gap-3'>
                            <p className='text-sm'>{currency}</p>
                            <p className='text-3xl font-bold'>{numberWithCommas(summary.settlements)}</p>
                        </div>
                        <Link to='/account/settlements'>
                            <p className='underline text-green-800 font-semibold mt-4'>
                                <a>View all transaction settlements</a>
                            </p>
                        </Link>
                    </div>
                </Card>
            </div>
            <div className='mt-10'>
                <div className='flex items-center'>
                    <div>
                        <p className='font-bold'>Transactions</p>
                        <p className=''>Track inflow and outflow of money over time</p>
                    </div>
                    <div className='ml-auto flex gap-4'>
                        <div className=''>
                            <Dropdown
                                label={
                                    <Button outline className='ring-gray-300'>
                                        <div className='flex items-center justify-center gap-2'>
                                            <FaFilter />
                                            {selectedItem}
                                        </div>
                                    </Button>
                                }
                                inline
                                arrowIcon={false}
                            >
                                <div className=' w-full py-4 px-2 flex flex-col justify-center item-center'>
                                    <p className='text-sm'>Date Range</p>
                                    <Dropdown.Item onClick={() => handleItemSelected('week')}>
                                        <div className='w-full text-left py-2 px-4 border rounded-lg'>This week</div>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => handleItemSelected('year')}>
                                        <div className='w-full py-2 px-4 border rounded-lg'>This year</div>
                                    </Dropdown.Item>
                                </div>
                            </Dropdown>
                        </div>
                        {/* <div className='flex gap-4 items-center'>
                            <Datepicker
                                onSelectedDateChanged={(date) => setFilter({ ...filter, fromDate: date.toISOString() })}
                            />{' '}
                            to
                            <Datepicker
                                onSelectedDateChanged={(date) => setFilter({ ...filter, toDate: date.toISOString() })}
                            />
                        </div> */}
                    </div>
                </div>
            </div>
            <hr className='mt-4' />
            <div>
                <div className='flex flex-col md:flex-row mt-3 gap-4'>
                    <div className='w-full md:w-1/3'>
                        <Card className='bg-gray-100'>
                            <div className='flex justify-between'>
                                <p className='font-semibold text-sm'>Available balance</p>
                                <Link to='/business/transactions'>
                                    <p className='underline text-green-600 text-sm'>View Transactions</p>
                                </Link>
                            </div>
                            <div className='flex mt-6 mb-10'>
                                <p className='text-sm'>{currency}</p>
                                <p className='font-bold text-3xl'>{numberWithCommas(summary.availableBalance)}</p>
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
                                <Button className='bg-custom-button-green w-full text-black hover:text-white' onClick={() => currency != "NGN" ? setOpenModal(false) : setOpenModal(true)}>
                                    <div className='flex items-center gap-2'>
                                        <BiWallet size={20} />
                                        Fund Account
                                    </div>
                                </Button>
                                <Button className='bg-custom-button-green text-black hover:text-white' onClick={() => currency != "NGN" ? setOpenTransferModal(false) : setOpenTransferModal(true)}>
                                    <div className='flex items-center gap-1'>
                                        <BiPaperPlane size={15} />
                                        Transfer
                                    </div>
                                </Button>
                            </div>
                        </Card>
                    </div>
                    <div className='w-full md:w-2/3'>
                        <Card>
                            <div className='flex text-sm'>
                                <p>Cash Flow</p>
                                <div className='flex gap-6 ml-auto'>
                                    <div className='flex justify-center items-center gap-2'>
                                        <div className='h-2 w-2 rounded-full bg-green-800'></div>
                                        <p>Total inflow</p>
                                    </div>
                                    <div className='flex items-center gap-2'>
                                        <div className='h-2 w-2 rounded-full bg-gray-300'></div>
                                        <p>Total Outflow</p>
                                    </div>
                                </div>
                            </div>
                            <p className='text-sm font-light'>Transactions from {selectedItem == 'week' ? ' last 7 days' : 'the months this year'}</p>
                            <div>
                                <VictoryChart theme={VictoryTheme.material} height={200}>
                                    <VictoryAxis
                                        style={{
                                            tickLabels: {
                                                angle: -90,
                                                textAnchor: 'end',
                                                fontSize: 8,
                                            },
                                        }} />
                                    <VictoryAxis
                                        dependentAxis
                                        style={{
                                            tickLabels: {
                                                fontSize: 8
                                            }
                                        }}

                                    />
                                    <VictoryBar
                                        style={{ data: { fill: '#166534' } }}
                                        alignment="start"
                                        data={graphData.map(item => ({ x: item.x, y: item.inflow }))}
                                        labels={({ datum }) => `Inflow: ${datum.y}`}
                                        labelComponent={<VictoryTooltip />}
                                    />
                                    <VictoryLine
                                        data={graphData.map(item => ({ x: item.x, y: item.outflow }))}
                                        style={{
                                            data: { stroke: '#d1d5db' },
                                        }}
                                    />
                                </VictoryChart>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
            <CustomModal icon={icon} size={openModal ? 'md' : 'lg'} dismissible children={openModal ? <FundWalletModal title="Fund Balance" data={ngnBalance} /> : openTransferModal ? <MakeTransferModal onSuccess={() => { }} close={() => setOpenTransferModal(false)} /> : null} show={openModal || openTransferModal} onClose={() => { setOpenModal(false); setOpenTransferModal(false); }} />
            {/* <CustomModal title='' size='md' show={openPinModal} dismissible icon='' onClose={() => setOpenPinModal(false)}>
                <NotificationPopupModal type={type} close={() => setOpenPinModal(false)} action={() => { handleCallToAction() }} message={type == 'intro' ? 'You need to create a PIN to carry out transactions' : type == 'pinCreationMessage' ? 'A verification code will be sent to your email' : ''} buttonText={type == 'intro' ? 'Create Pin' : type == 'pinCreationMessage' ? loading ? <Spinner /> : 'Send code' : ''} />
                <CreatePinModal type='create' onSuccess={()=> setOpenPinModal(false)} message='Create Your PIN' buttonText=''/>
            </CustomModal>  */}
            {/* <CustomModal title='' size='md' show={openOtpModal} icon='' onClose={() => setOpenOtpModal(false)} dismissible>
                <OtpVerificationModal closeAllModals={() => { setOpenOtpModal(false) }} close={() => setOpenOtpModal(false)} />
            </CustomModal> */}
        </div>
    );
};

export default Dashboard;
